import {
  CUSTOMERS_REQUEST, CUSTOMERS_SUCCESS,
  CUSTOMERS_STATUS_REQUEST, CUSTOMERS_STATUS_SUCCESS
} from '../constants/actionTypes';

import {ActionTypes} from '../actions/customers';

const initialState = {
  data: {
    errors: [],
    page: 0,
    pageSize: 50,
    rows: [],
    totalPages: 0
  },
  loading: false,
  searchKeyword: '',
  statusUpdateSuccess: false,

  // used for switching the user
  enabledEntities: {
    data: {
      page: 0,
      rows: [],
      totalPages: 0
    },
    term: '',
    loading: false,
    statusUpdateSuccess: false
  }
};

function processEnabledEntitiesRequest(state, {payload}) {
  const {enabledEntities} = state;
  enabledEntities.loading = true;
  enabledEntities.term = payload.term;
  enabledEntities.data.page = payload.page;
  enabledEntities.statusUpdateSuccess = false;
  return {...state, enabledEntities};
}

function processEnabledEntitiesResponse(state, {payload}) {
  const {enabledEntities} = state;
  enabledEntities.loading = false;
  enabledEntities.data = {...payload};
  enabledEntities.statusUpdateSuccess = true;
  return {...state, enabledEntities};
}

export default function customers(state = initialState, action) {
  switch (action.type) {
    case CUSTOMERS_REQUEST:
      return {
        ...state,
        searchKeyword: action.searchKeyword,
        loading: true,
        statusUpdateSuccess: false
      };
    case CUSTOMERS_STATUS_REQUEST:
      return {
        ...state,
        loading: false,
        statusUpdateSuccess: false
      };
    case CUSTOMERS_SUCCESS:
      return {
        ...state,
        data: action.data,
        statusUpdateSuccess: false,
        loading: false
      };
    case CUSTOMERS_STATUS_SUCCESS:
      return {
        ...state,
        statusUpdateSuccess: true
      };
    case ActionTypes.GET_ENABLED_ENTITIES_REQUEST:
      return processEnabledEntitiesRequest(state, action);
    case ActionTypes.GET_ENABLED_ENTITIES_RESPONSE:
      return processEnabledEntitiesResponse(state, action);
    default:
      return state;
  }
}
